/**
 * @file: 分销2.0  创建子账号
 *
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2022/05/20      2.0     Second version
 *
 * Copyright 2022, all rights reserved. Essa.cn
 * */

import React from "react";
import {Button, message, Modal, Spin,Divider,Alert,Space } from 'antd';
import AddAndEditForm from '../AddAndEditForm/index';
import Lang from "@/components/Lang/Lang";
import { isEmpty} from "@utils/utils";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import PropTypes from "prop-types";
import qs from 'qs';
import "../DistributionCenter.less";
import "./Index.less";
class DistributionAccountInfo extends React.Component {
    static propTypes = {
    }
    static defaultProps = {
    };
    constructor(props) {
        super(props);
        this.state = {
            loading:false,
            sTypeFrom:'',// 来源页面:提成分销新增将传入 typefrom=orderCommission
            defaultValue4Img: [],
            userInfo: {},
            fieldList: [],
            showSuccess:false,
            fromData:{}
        }
    }
    /**
     * 加载
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    /**
     * 请求
     * */
    postHttpAction(sUrl,data,callback){
        return $.ajax({
            url: sUrl,
            type:'post',
            dataType: "json",
            contentType: 'application/json',
            data:JSON.stringify(data),
            success:(res)=>{
                callback(res)
            }
        });
    }
    onRefFormAdd = (ref) =>  this.onRefFormFormatAdd = ref;
    /**
     * 点击确认时 获取表单数据
     * http://rap.essa.top:88/workspace/myWorkspace.do?projectId=157#4658
     ***/
    async handleOK(){
        const res = await this.onRefFormFormatAdd.handleOK();
        if(res&&res.success){
            //   /data/service/fenxiao/basic-info/edit
            const { sTypeFrom} = this.state;
            let postData = {
                ...res.data,
                type: sTypeFrom=='orderCommission'?"1":"0",//传入 typefrom=orderCommission 即为订单提成分销 0：注册提成 1：订单提成
            }
            const sUrl = "/service/fenxiao/basic-info/add";
            this.loading(true);
            this.postHttpAction(sUrl, postData, (resData) => {
                const { success, valid} = resData;
                if (success &&valid) {
                    // 保存成功
                    this.setState({
                        showSuccess: true,
                        fromData: postData
                    })
                    // this.getInfo()
                }else if(resData.message){
                    message.warning(resData.message)
                }else {
                    message.warning(__getServerLanguage("BaoCunShiBai"))
                }
                this.loading(false);
            });
        }
    }
    /**
     * 获取用户
     * */
    // 显示成功提示
    showSuccess(flag=false){
        this.setState({
            showSuccess: flag,
        })
        if(!false){
            this.loading(true)
            const {sTypeFrom} = this.state;
            window.location.href = sTypeFrom=='orderCommission'?"/distributor/extractDistributionList":'/distributor/list';
        }
    }
    /**
     * 复制
     **/
    copyText(fromData={}) {
        {/* 账号 密码*/}
        const text =__getServerLanguage("ZhangHao")+'：'+ fromData.mobile+'，' + __getServerLanguage("MiMa")+'：'+fromData.mobile;
        let key = 'execCommandAgent';
        let agent = document.getElementById(key);
        if (!agent) {
            const e = document.createElement('input');
            e.id = key;
            e.style.position = 'absolute';
            e.style.top = '-40px';
            e.style.left = 0;
            document.body.appendChild(e);
            agent = document.getElementById(key);
        }
        agent.value = text;
        agent.select();
        document.execCommand("Copy"); // 执行浏览器复制命令
        message.success(Lang({id:"FuZhiChengGong",default:"复制成功"}))
    }
    componentWillMount() {
        const { search } = this.props.location;
        const list = qs.parse(search)||{};
        const sType =list['?typefrom']
        this.setState({
            sTypeFrom:sType,
        })
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render() {
        const { loading, showSuccess, fromData,sTypeFrom} = this.state;
        // 默认 注册分销，传入typefrom=orderCommission 即为提成分销
        const currPageName = sTypeFrom=='orderCommission'?Lang({id: "TiChengFenXiaoShang",default: "提成分销商"}):Lang({id: "ZhuCeFenXiaoShang",default: "注册分销商"});
        return (<Spin spinning={loading}>
            <CommonBreadcrumb list={[
                { name:currPageName,link:sTypeFrom=='orderCommission'?"/distributor/extractDistributionList":'/distributor/list'},
                {name:__getServerLanguage("XinZengFenXiaoShang")}]}></CommonBreadcrumb>
                <div className="distribution black89">
                    {/* 新增分销商 */}
                    <div className={"font-16 fw_700"}>
                        {sTypeFrom=='orderCommission'?Lang({id: "XinZengDingDanTiChengFenXiaoShang",default: "新增订单提成分销商"}):Lang(
                            {id: "XinZengZhuCeTiChengFenXiaoShang",default: "新增注册提成分销商"})
                        }
                    </div>
                    <div className={"lineBorder mt_12"}>
                        {/*  表单 start */}
                        {<AddAndEditForm onRef={this.onRefFormAdd}
                                         loading={loading}
                                         typeFrom={sTypeFrom} // 订单提成 为 sTypeFrom：订单提成 'orderCommission' ，注册提成：空， 不显示合同
                        />}
                        {/*  表单 end */}
                    </div>
                    {/* 操作 */}
                    <Button type="primary" size={"large"}
                            loading={loading}
                            onClick={()=>this.handleOK()}>{__getServerLanguage("BaoCun")}</Button>

                    {/* 操作 end*/}
                {showSuccess&&<Modal
                    open={showSuccess}
                    className={"pop-success-add"}
                    footer={null}
                    onCancel={()=>this.showSuccess(false)}>
                    <div className={"top-tips"}>
                        {/* 新增成功 */}
                        <div className={"black89 font_18 fw_500"}>{__getServerLanguage("XinZengChengGong")}</div>
                        {/* 账号 */}
                        <p>{__getServerLanguage("ZhangHao")}：{fromData.mobile}</p>
                        {/*  密码 MiMa */}
                        <p>{__getServerLanguage("MiMa")}：{fromData.password}</p>
                    </div>
                    <Space className={"footer-btn"}>
                        <Button type="primary" key="console"  onClick={()=>this.copyText(fromData)}>
                            {__getServerLanguage("FuZhiZhangHaoMiMa")}
                        </Button>
                        <Button className={"margin-left-10"} onClick={()=>this.showSuccess(false)}>
                            {__getServerLanguage("FanHui")}
                        </Button>
                    </Space>
                </Modal>}
            </div>
        </Spin>);
    }
}

export default DistributionAccountInfo;
